import { render, staticRenderFns } from "./home-view.vue?vue&type=template&id=52b40ef7&"
import script from "./home-view.vue?vue&type=script&lang=js&"
export * from "./home-view.vue?vue&type=script&lang=js&"
import style0 from "./home-view.vue?vue&type=style&index=0&id=52b40ef7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports